import { type AxiosInstance, type AxiosError } from "axios";
import useSWR from "swr";
import type { KeyedMutator } from "swr";
import type { Order } from "@/features/dmManagement/types";
import { swrErrorHandler } from "@/features/dmManagement/api/handleApiError";

interface IResponse {
  data: Order[] | undefined;
  isLoading: boolean;
  mutate: KeyedMutator<Order[]>;
  error: AxiosError | undefined;
}

/**
 * 発注一覧を取得する。
 * @param apiClient - axios インスタンス
 * @param params - 絞り込み・並び替え条件（status, ordering）
 * @returns 発注一覧・ローディング状態・mutate関数・エラー
 */
export const GetOrdersAPI = (
  apiClient: AxiosInstance,
  params?: { status?: string; ordering?: string }
): IResponse => {
  const fetcher = async (url: string): Promise<Order[]> => {
    const { data } = await apiClient.get<Order[]>(url, { params });
    return data;
  };

  const { data, isLoading, mutate, error } = useSWR<Order[], AxiosError>(
    ["/dm/orders/", params],
    async ([url]: [string]) => await fetcher(url),
    {
      revalidateOnFocus: false,
      onError: swrErrorHandler,
    }
  );

  return { data, isLoading, mutate, error };
};
